<ng-container *ngIf="unreadMessageCount$ | async; else noNotifications">
  <i
    (click)="showOverlayPanel($event)"
    *ngIf="asOverlayPanel"
    [value]="unreadMessageCount$ | async"
    class="pi pi-bell mr-4 text-secondary cursor-pointer"
    pBadge
    style="font-size: 2rem"
  ></i>
</ng-container>

<ng-template #noNotifications>
  <i
    (click)="showOverlayPanel($event)"
    class="pi pi-bell mr-4 text-secondary cursor-pointer"
    style="font-size: 2rem"
  ></i>
</ng-template>

<ul
  [ngClass]="{
    'notifications-menu': asOverlayPanel,
    'fade-in-up': asOverlayPanel
  }"
  class="px-0 fadein animation-duration-500"
>
  <li>
    <ng-container *ngIf="showHeader">
      <h5 class="flex align-items-center justify-content-between ml-2">
        Notifications
        <!--        Replace with a pop up menu-->
        <span
          ><button
            (click)="refreshNotifications()"
            class="p-button-text"
            icon="pi pi-refresh"
            pButton
            pRipple
            type="button"
          ></button
        ></span>
      </h5>
    </ng-container>

    <ng-container *ngIf="!showHeader">
      <div class="flex align-items-center justify-content-between">
        <span>
          <button
            (click)="refreshNotifications()"
            class="p-button-text"
            icon="pi pi-refresh"
            label="Refresh"
            pButton
            pRipple
            type="button"
          ></button>
        </span>
        <span>
          <button
            (click)="markAllAsRead()"
            class="p-button-text"
            label="Mark As Read"
            pButton
            pRipple
            type="button"
          ></button>
        </span>
      </div>
      <hr />
    </ng-container>
  </li>
  <ng-container *ngTemplateOutlet="notificationsList"></ng-container>
  <li class="text-center">
    <button
      (click)="loadNextPage()"
      *ngIf="nextPage"
      class="mt-3"
      label="Load More"
      pButton
      type="button"
    ></button>
    <h5 *ngIf="!this.nextPage">
      All Caught Up, no more Notifications to Display.
    </h5>
  </li>
</ul>

<ng-template #notificationsList>
  <ng-container *ngFor="let message of messages$ | async; index as i">
    <notification-list-item
      [id]="message.id"
      [message]="message"
    ></notification-list-item>
  </ng-container>
</ng-template>
